import store from './store';
import config from '../const/config';
export var POSTMAN_URL = 'https://a2e502b0-453c-41d9-a839-eea61e73a6e7.mock.pstmn.io';
var currentLanguage = store.get('language', 'local');
var isMockData = Boolean(sessionStorage.getItem('mockData'));
var apiHost = !isMockData ? config.API_HOST : POSTMAN_URL;
var accountActionsConfig = {
    hosts: {
        apigee: new URL(apiHost),
        assets: new URL('https://qa.synchronycredit.com')
    },
    apiErrorCallback: function () { return undefined; },
    lang: currentLanguage
};
export default accountActionsConfig;
